import { createTheme } from '@mui/material';
import { Appearance, colorPalette } from 'presentations/views/styles/color';

interface Props {
  appearance: Appearance;
}

const createMuiTheme = (props: Props) => {
  const mode = props.appearance;
  return createTheme({
    typography: {
      button: {
        textTransform: 'none',
      },
      fontFamily: [
        'Helvetica Neue',
        'Arial',
        'Hiragino Kaku Gothic ProN',
        'Hiragino Sans',
        'Meiryo',
        '-apple-system',
        'BlinkMacSystemFont',
        'sans-serif',
      ].join(','),
    },
    palette: {
      mode: props.appearance === Appearance.Dark ? 'dark' : undefined,
      primary: {
        main: colorPalette.primary[mode],
        dark: colorPalette.primaryVariantDark[mode],
        light: colorPalette.primaryVariantLight[mode],
      },
      secondary: {
        main: colorPalette.secondary[mode],
        dark: colorPalette.secondaryVariantDark[mode],
        light: colorPalette.secondaryVariantLight[mode],
      },
      error: {
        main: colorPalette.error[mode],
      },
      success: {
        main: colorPalette.success[mode],
      },
      text: {
        primary: colorPalette.black[mode],
        secondary: colorPalette.gray01[mode],
        disabled: colorPalette.gray02[mode],
      },
      background: {
        paper: colorPalette.paper[mode],
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 350,
        md: 768,
        lg: 1080,
        xl: 1440,
      },
    },
    components: {
      // MuiPaper: {
      //   styleOverrides: {
      //     root: {
      //       borderRadius: 16,
      //       boxShadow: 'rgb(0 0 0 / 15%) 0px 8px 20px 0px',
      //     },
      //   },
      // },
      // MuiPickersDay: {
      //   day: {
      //     color: colorPalette.primary[mode],
      //     background: colorPalette.blue03[mode],
      //     '&:hover': {
      //       color: colorPalette.white[mode],
      //       background: colorPalette.primary[mode],
      //     },
      //   },
      //   dayDisabled: {
      //     color: 'rgba(0, 0, 0, 0.38)',
      //     background: colorPalette.white[mode],
      //   },
      //   current: {
      //     color: colorPalette.primary[mode],
      //     background: colorPalette.white[mode],
      //     '&:hover': {
      //       color: colorPalette.white[mode],
      //       background: colorPalette.primary[mode],
      //     },
      //   },
      // },
    },
  });
};

export default createMuiTheme;
